import type { HelpFile } from '../../types/help'
import { AccessRequestDetailTestIds } from '../../../testids/AccessRequestDetailTestIds'

export const accessRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestDetailTestIds.accessRequestDetailPage]:
      'Vollständige Detailansicht eines Zugriffsantrags — Begünstigte:r, beantragte Positionen, Begründung und Genehmigungsstatus. Solange der Workflow läuft, können der Antrag oder einzelne Positionen hier zurückgezogen werden.',
    [AccessRequestDetailTestIds.cardTitleRequestItems]: 'Positionen dieses Antrags. Jede Position hat einen eigenen Genehmigungsstatus und kann während der Antragslaufzeit einzeln zurückgezogen werden.',
    [AccessRequestDetailTestIds.cardTitleRequestDetails]: 'Metadaten dieses Zugriffsantrags: Antragsteller:in, Begünstigte:r und Einreichungszeitpunkt.',
    [AccessRequestDetailTestIds.cardTitleJustification]: 'Die fachliche Begründung, die der/die Antragsteller:in beim Erstellen des Antrags angegeben hat.',
    [AccessRequestDetailTestIds.btnCancelRequest]: 'Den gesamten Zugriffsantrag zurückziehen. Alle offenen Positionen werden ebenfalls zurückgezogen.',
    [AccessRequestDetailTestIds.approveDialog]: null,
    [AccessRequestDetailTestIds.rejectDialog]: null,
    [AccessRequestDetailTestIds.cancelItemDialog]: null,
    [AccessRequestDetailTestIds.cancelRequestDialog]: null,
  },
}
